import { memo } from "react";

function Icon_MidstreamSalesFacilities() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_59_30)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 8V16H0V4.7998L4 8V4.7998L8 8V4.7998L12 8L12.7998 0H15.2002L16 8ZM7.55078 8.82812V9.4873C7.2422 9.49199 6.97112 9.54876 6.7373 9.65625C6.50339 9.76385 6.32045 9.9115 6.18945 10.0986C6.06326 10.2857 6 10.4988 6 10.7373V11.1299C6.00001 11.4386 6.10805 11.6934 6.32324 11.8945C6.54312 12.091 6.86322 12.2248 7.28418 12.2949L8.5752 12.5127C8.91204 12.5688 9.08105 12.7112 9.08105 12.9404V13.1787C9.08105 13.3237 9.01478 13.4414 8.88379 13.5303C8.75754 13.6143 8.59131 13.6562 8.38574 13.6562H7.60742C7.38754 13.6562 7.21421 13.5878 7.08789 13.4521C6.96637 13.3118 6.90527 13.1201 6.90527 12.877H5.95117C5.95117 13.3822 6.09137 13.7803 6.37207 14.0703C6.65742 14.3603 7.05033 14.508 7.55078 14.5127V15.1719H8.50488V14.5127C8.97259 14.494 9.34725 14.3697 9.62793 14.1406C9.90863 13.9114 10.0488 13.6139 10.0488 13.249V12.7861C10.0488 12.4867 9.93647 12.2428 9.71191 12.0557C9.48745 11.8641 9.16252 11.7311 8.7373 11.6562L7.45312 11.4316C7.13032 11.3755 6.96875 11.23 6.96875 10.9961V10.8066C6.96886 10.6665 7.0267 10.5539 7.14355 10.4697C7.26519 10.3855 7.4246 10.3438 7.62109 10.3438H8.41406C8.59177 10.3438 8.73421 10.4048 8.8418 10.5264C8.94933 10.6432 9.00383 10.7998 9.00391 10.9961H9.95801C9.95793 10.5565 9.8242 10.2009 9.55762 9.92969C9.29565 9.65848 8.94453 9.51069 8.50488 9.4873V8.82812H7.55078Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_59_30">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(Icon_MidstreamSalesFacilities);
